import GA from '../../shared/tracking/ga'

const trackSendFormSuccess = () => GA.send({
  name: 'signup',
  category: 'register',
  action: 'send_form',
})

const trackSendFormError = () => GA.send({
  name: 'signup',
  category: 'register',
  action: 'failed_form',
})

export {
  trackSendFormSuccess,
  trackSendFormError,
}
